import ProgrammingProblems from "../../components/Programming/ProgrammingProblems"

const Programming = () => {
     return (
          <>
          <ProgrammingProblems />
          </>
     )
}

export default Programming